import React, { useState, useRef, useEffect } from 'react';
import { MoreVertical, UserCheck, Ban, Mail, Eye, Trash } from 'lucide-react';

const UserActionsDropdown = ({ user, onActivate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="text-gray-400 hover:text-gray-500"
      >
        <MoreVertical className="h-5 w-5" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
          <div className="py-1" role="menu">
            {user.activationStatus !== 'active' && (
              <button
                onClick={() => {
                  onActivate(user._id);
                  setIsOpen(false);
                }}
                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
              >
                <UserCheck className="h-4 w-4 mr-3" />
                Activate User
              </button>
            )}
            <button
              onClick={() => {
                console.log('View profile');
                setIsOpen(false);
              }}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
            >
              <Eye className="h-4 w-4 mr-3" />
              View Profile
            </button>
            <button
              onClick={() => {
                console.log('Send email');
                setIsOpen(false);
              }}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
            >
              <Mail className="h-4 w-4 mr-3" />
              Send Email
            </button>
            {user.activationStatus === 'active' && (
              <button
                onClick={() => {
                  console.log('Suspend user');
                  setIsOpen(false);
                }}
                className="flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50 w-full text-left"
              >
                <Ban className="h-4 w-4 mr-3" />
                Suspend User
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserActionsDropdown;